import { render } from "./AlertFailed.vue?vue&type=template&id=763548a6&scoped=true"
import script from "./AlertFailed.vue?vue&type=script&lang=js"
export * from "./AlertFailed.vue?vue&type=script&lang=js"

import "./AlertFailed.vue?vue&type=style&index=0&id=763548a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763548a6"]])

export default __exports__